import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserModel } from '../../models/user/user.model';

export const selectUsers = createSelector(
  createFeatureSelector('users'),
  (users: UserModel[]) => users,
);

export const selectUser = (userId: number) =>
  createSelector(selectUsers, (users) => {
    return users.find((user) => user.id === userId);
  });
